(function () {
  "use strict";

  const MIN_SIZE = 1000;
  const REQUIRED_IMAGE_COUNT = 6;

  let cropState = null;

  // =========================================================
  // VALIDATION MESSAGES
  // =========================================================

  function getStatusElement(input) {
    let status = input
      .closest(".gpo-dropzone")
      ?.querySelector(".custom-image-validation");

    if (!status) {
      status = document.createElement("div");
      status.className = "custom-image-validation";
      status.style.marginTop = "8px";
      status.style.fontSize = "13px";
      status.style.fontWeight = "600";

      const container =
        input.closest(".gpo-dropzone") || input.parentElement;

      container.appendChild(status);
    }

    return status;
  }

  function showMessage(input, message, valid) {
    const status = getStatusElement(input);

    status.style.color = valid ? "#188038" : "#c62828";
    status.textContent = message;
  }

  // =========================================================
  // CROPPER
  // =========================================================

  function createCropper() {
    if (document.getElementById("custom-cube-cropper")) {
      return;
    }

    const modal = document.createElement("div");
    modal.id = "custom-cube-cropper";

    modal.innerHTML = `
      <div class="ccc-overlay">
        <div class="ccc-window">

          <button
            type="button"
            class="ccc-close"
            aria-label="Close cropper"
          >×</button>

          <h3>Crop your image</h3>

          <p class="ccc-instructions">
            Position your image inside the square.
            Everything inside the square will be printed on this face.
          </p>

          <div class="ccc-canvas-wrap">
            <canvas id="ccc-canvas"></canvas>
          </div>

          <div class="ccc-controls">
            <label>
              Zoom
              <input
                id="ccc-zoom"
                type="range"
                min="1"
                max="3"
                step="0.01"
                value="1"
              >
            </label>
          </div>

          <p class="ccc-resolution"></p>

          <div class="ccc-buttons">
            <button
              type="button"
              class="ccc-cancel"
            >
              Cancel
            </button>

            <button
              type="button"
              class="ccc-use"
            >
              Use this crop
            </button>
          </div>

        </div>
      </div>
    `;

    document.body.appendChild(modal);

    addCropperStyles();

    modal
      .querySelector(".ccc-close")
      .addEventListener("click", closeCropper);

    modal
      .querySelector(".ccc-cancel")
      .addEventListener("click", closeCropper);

    modal
      .querySelector(".ccc-use")
      .addEventListener("click", finishCrop);

    modal
      .querySelector("#ccc-zoom")
      .addEventListener("input", function () {
        if (!cropState) return;

        cropState.zoom = parseFloat(this.value);

        constrainPosition();
        drawCropper();
      });

    setupCanvasDragging();
  }

  // =========================================================
  // CROPPER STYLES
  // =========================================================

  function addCropperStyles() {
    if (document.getElementById("ccc-styles")) {
      return;
    }

    const style = document.createElement("style");
    style.id = "ccc-styles";

    style.textContent = `
      #custom-cube-cropper {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 999999;
      }

      #custom-cube-cropper.active {
        display: block;
      }

      .ccc-overlay {
        position: absolute;
        inset: 0;
        background: rgba(0, 0, 0, 0.72);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
      }

      .ccc-window {
        position: relative;
        background: #fff;
        width: 100%;
        max-width: 560px;
        max-height: 95vh;
        overflow-y: auto;
        padding: 24px;
        border-radius: 8px;
        box-sizing: border-box;
        text-align: center;
      }

      .ccc-window h3 {
        margin: 0 30px 8px;
        font-size: 22px;
      }

      .ccc-instructions {
        margin: 0 0 18px;
        font-size: 14px;
        line-height: 1.5;
      }

      .ccc-close {
        position: absolute;
        right: 12px;
        top: 8px;
        border: 0;
        background: none;
        font-size: 30px;
        line-height: 1;
        cursor: pointer;
      }

      .ccc-canvas-wrap {
        width: 100%;
        max-width: 450px;
        aspect-ratio: 1 / 1;
        margin: 0 auto;
        background: #eee;
        overflow: hidden;
        border: 2px solid #222;
        box-sizing: border-box;
      }

      #ccc-canvas {
        width: 100%;
        height: 100%;
        display: block;
        cursor: grab;
        touch-action: none;
      }

      #ccc-canvas:active {
        cursor: grabbing;
      }

      .ccc-controls {
        margin-top: 18px;
      }

      .ccc-controls label {
        display: flex;
        align-items: center;
        gap: 12px;
        justify-content: center;
        font-size: 14px;
      }

      #ccc-zoom {
        width: 220px;
        max-width: 65%;
      }

      .ccc-resolution {
        min-height: 20px;
        margin: 12px 0 4px;
        font-size: 13px;
      }

      .ccc-buttons {
        display: flex;
        gap: 10px;
        justify-content: center;
        margin-top: 14px;
      }

      .ccc-buttons button {
        border: 1px solid #222;
        padding: 10px 18px;
        cursor: pointer;
        font-size: 14px;
        border-radius: 4px;
      }

      .ccc-cancel {
        background: #fff;
        color: #222;
      }

      .ccc-use {
        background: #222;
        color: #fff;
      }

      @media (max-width: 600px) {
        .ccc-overlay {
          padding: 10px;
        }

        .ccc-window {
          padding: 18px 14px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  // =========================================================
  // OPEN / CLOSE CROPPER
  // =========================================================

  function openCropper(input, file, img) {
    createCropper();

    const modal =
      document.getElementById("custom-cube-cropper");

    const zoomInput =
      modal.querySelector("#ccc-zoom");

    const shortSide = Math.min(
      img.naturalWidth,
      img.naturalHeight
    );

    /*
     * Don't allow the customer to zoom so far that
     * the resulting crop falls below 1000 × 1000.
     */
    const maxUsefulZoom = Math.max(
      1,
      shortSide / MIN_SIZE
    );

    cropState = {
      input: input,
      file: file,
      image: img,
      zoom: 1,
      x: 0,
      y: 0,
      dragging: false,
      dragStartX: 0,
      dragStartY: 0,
      positionStartX: 0,
      positionStartY: 0
    };

    zoomInput.min = 1;
    zoomInput.max = maxUsefulZoom;
    zoomInput.step = 0.01;
    zoomInput.value = 1;

    centreImage();

    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    drawCropper();
  }

  function closeCropper() {
    const modal =
      document.getElementById("custom-cube-cropper");

    if (modal) {
      modal.classList.remove("active");
    }

    document.body.style.overflow = "";

    if (cropState?.input) {
      cropState.input.value = "";
      cropState.input.dataset.imageValid = "false";
    }

    cropState = null;
  }

  // =========================================================
  // CROP GEOMETRY
  // =========================================================

  function getCropSize() {
    if (!cropState) return 0;

    return (
      Math.min(
        cropState.image.naturalWidth,
        cropState.image.naturalHeight
      ) / cropState.zoom
    );
  }

  function centreImage() {
    if (!cropState) return;

    const img = cropState.image;
    const cropSize = getCropSize();

    cropState.x =
      (img.naturalWidth - cropSize) / 2;

    cropState.y =
      (img.naturalHeight - cropSize) / 2;
  }

  function constrainPosition() {
    if (!cropState) return;

    const img = cropState.image;
    const cropSize = getCropSize();

    const maxX = Math.max(
      0,
      img.naturalWidth - cropSize
    );

    const maxY = Math.max(
      0,
      img.naturalHeight - cropSize
    );

    cropState.x = Math.max(
      0,
      Math.min(cropState.x, maxX)
    );

    cropState.y = Math.max(
      0,
      Math.min(cropState.y, maxY)
    );
  }

  // =========================================================
  // DRAW CROPPER
  // =========================================================

  function drawCropper() {
    if (!cropState) return;

    const canvas =
      document.getElementById("ccc-canvas");

    const resolution =
      document.querySelector(".ccc-resolution");

    if (!canvas || !resolution) return;

    const displaySize = 500;

    canvas.width = displaySize;
    canvas.height = displaySize;

    const ctx = canvas.getContext("2d");
    const cropSize = getCropSize();

    ctx.clearRect(
      0,
      0,
      displaySize,
      displaySize
    );

    ctx.drawImage(
      cropState.image,
      cropState.x,
      cropState.y,
      cropSize,
      cropSize,
      0,
      0,
      displaySize,
      displaySize
    );

    const actualPixels =
      Math.floor(cropSize);

    if (actualPixels >= MIN_SIZE) {
      resolution.style.color = "#188038";

      resolution.textContent =
        "✓ Cropped image resolution: " +
        actualPixels +
        " × " +
        actualPixels +
        " px";
    } else {
      resolution.style.color = "#c62828";

      resolution.textContent =
        "✕ Crop is below the minimum " +
        MIN_SIZE +
        " × " +
        MIN_SIZE +
        " px";
    }
  }

  // =========================================================
  // CROPPER DRAGGING
  // =========================================================

  function setupCanvasDragging() {
    const canvas =
      document.getElementById("ccc-canvas");

    if (!canvas) return;

    canvas.addEventListener(
      "pointerdown",
      function (event) {
        if (!cropState) return;

        cropState.dragging = true;

        cropState.dragStartX =
          event.clientX;

        cropState.dragStartY =
          event.clientY;

        cropState.positionStartX =
          cropState.x;

        cropState.positionStartY =
          cropState.y;

        canvas.setPointerCapture(
          event.pointerId
        );
      }
    );

    canvas.addEventListener(
      "pointermove",
      function (event) {
        if (
          !cropState ||
          !cropState.dragging
        ) {
          return;
        }

        const rect =
          canvas.getBoundingClientRect();

        const cropSize =
          getCropSize();

        const dx =
          (event.clientX -
            cropState.dragStartX) *
          (cropSize / rect.width);

        const dy =
          (event.clientY -
            cropState.dragStartY) *
          (cropSize / rect.height);

        cropState.x =
          cropState.positionStartX - dx;

        cropState.y =
          cropState.positionStartY - dy;

        constrainPosition();
        drawCropper();
      }
    );

    function stopDragging() {
      if (cropState) {
        cropState.dragging = false;
      }
    }

    canvas.addEventListener(
      "pointerup",
      stopDragging
    );

    canvas.addEventListener(
      "pointercancel",
      stopDragging
    );
  }

  // =========================================================
  // CREATE CROPPED FILE
  // =========================================================

  function finishCrop() {
    if (!cropState) return;

    const input = cropState.input;
    const originalFile = cropState.file;
    const img = cropState.image;

    const cropSize = getCropSize();
    const outputSize =
      Math.floor(cropSize);

    if (outputSize < MIN_SIZE) {
      return;
    }

    const output =
      document.createElement("canvas");

    output.width = outputSize;
    output.height = outputSize;

    const ctx =
      output.getContext("2d");

    ctx.drawImage(
      img,
      cropState.x,
      cropState.y,
      cropSize,
      cropSize,
      0,
      0,
      outputSize,
      outputSize
    );

    let mimeType =
      originalFile.type;

    if (
      mimeType !== "image/jpeg" &&
      mimeType !== "image/png"
    ) {
      mimeType = "image/jpeg";
    }

    output.toBlob(
      function (blob) {
        if (!blob) {
          alert(
            "The cropped image could not be created. Please try again."
          );
          return;
        }

        const originalName =
          originalFile.name.replace(
            /\.[^/.]+$/,
            ""
          );

        const extension =
          mimeType === "image/png"
            ? ".png"
            : ".jpg";

        const croppedFile =
          new File(
            [blob],
            originalName +
              "-cropped" +
              extension,
            {
              type: mimeType,
              lastModified: Date.now()
            }
          );

        /*
         * Replace the customer's original file with
         * the square cropped file.
         */
        const transfer =
          new DataTransfer();

        transfer.items.add(
          croppedFile
        );

        input.files =
          transfer.files;

        input.dataset.imageValid =
          "true";

        input.dataset.allowGlobo =
          "true";

        showMessage(
          input,
          "✓ " +
            outputSize +
            " × " +
            outputSize +
            " px — cropped and suitable for printing",
          true
        );

        const modal =
          document.getElementById(
            "custom-cube-cropper"
          );

        if (modal) {
          modal.classList.remove(
            "active"
          );
        }

        document.body.style.overflow =
          "";

        cropState = null;

        /*
         * Send the validated cropped file to Globo.
         */
        input.dispatchEvent(
          new Event("change", {
            bubbles: true
          })
        );
      },
      mimeType,
      0.95
    );
  }

  // =========================================================
  // INTERCEPT GLOBO FILE SELECTION
  // =========================================================

  document.addEventListener(
    "change",
    function (event) {
      const input = event.target;

      if (
        !input.matches ||
        !input.matches(
          'input.gpo-file[type="file"]'
        )
      ) {
        return;
      }

      /*
       * This is a file we've already validated.
       * Allow Globo to process this change event.
       */
      if (
        input.dataset.allowGlobo ===
        "true"
      ) {
        input.dataset.allowGlobo =
          "false";

        return;
      }

      if (
        !input.files ||
        !input.files[0]
      ) {
        return;
      }

      const file =
        input.files[0];

      /*
       * Prevent Globo from receiving the original
       * file before we've validated it.
       */
      event.stopImmediatePropagation();

      /*
       * A newly selected image is not valid until
       * it passes the checks below.
       */
      input.dataset.imageValid =
        "false";

      if (
        !file.type.startsWith(
          "image/"
        )
      ) {
        showMessage(
          input,
          "✕ Please upload a JPG or PNG image.",
          false
        );

        input.value = "";

        return;
      }

      const img =
        new Image();

      const objectURL =
        URL.createObjectURL(file);

      img.onload = function () {
        const width =
          img.naturalWidth;

        const height =
          img.naturalHeight;

        URL.revokeObjectURL(
          objectURL
        );

        const shortSide =
          Math.min(
            width,
            height
          );

        const isSquare =
          width === height;

        // -----------------------------------------
        // IMAGE TOO SMALL
        // -----------------------------------------

        if (
          shortSide <
          MIN_SIZE
        ) {
          input.value = "";

          input.dataset.imageValid =
            "false";

          if (isSquare) {
            showMessage(
              input,
              "✕ " +
                width +
                " × " +
                height +
                " px — minimum resolution is " +
                MIN_SIZE +
                " × " +
                MIN_SIZE +
                " px",
              false
            );
          } else {
            showMessage(
              input,
              "✕ " +
                width +
                " × " +
                height +
                " px — this image is too small to crop to " +
                MIN_SIZE +
                " × " +
                MIN_SIZE +
                " px",
              false
            );
          }

          return;
        }

        // -----------------------------------------
        // ALREADY SQUARE
        // -----------------------------------------

        if (isSquare) {
          input.dataset.imageValid =
            "true";

          showMessage(
            input,
            "✓ " +
              width +
              " × " +
              height +
              " px — suitable for printing",
            true
          );

          input.dataset.allowGlobo =
            "true";

          /*
           * Globo can now upload the validated
           * original image.
           */
          input.dispatchEvent(
            new Event("change", {
              bubbles: true
            })
          );

          return;
        }

        // -----------------------------------------
        // RECTANGULAR BUT LARGE ENOUGH TO CROP
        // -----------------------------------------

        showMessage(
          input,
          "Image is " +
            width +
            " × " +
            height +
            " px — crop it to square to continue.",
          false
        );

        openCropper(
          input,
          file,
          img
        );
      };

      img.onerror = function () {
        URL.revokeObjectURL(
          objectURL
        );

        input.value = "";

        input.dataset.imageValid =
          "false";

        showMessage(
          input,
          "✕ This image could not be read. Please choose another file.",
          false
        );
      };

      img.src = objectURL;
    },

    /*
     * Capture phase lets us intercept the file
     * before Globo's own listener receives it.
     */
    true
  );

  // =========================================================
  // SIX-IMAGE ADD-TO-CART VALIDATION
  // =========================================================

  function getDesignInputs() {
    return Array.from(
      document.querySelectorAll(
        '.gpo-element[data-element-id^="file-"] input.gpo-file[type="file"]'
      )
    ).filter(function (input) {
      const element =
        input.closest(
          ".gpo-element"
        );

      /*
       * Ignore hidden conditional Globo fields.
       */
      return (
        element &&
        element.offsetParent !== null
      );
    });
  }

  function getCartValidationMessage(
    button
  ) {
    let message =
      document.getElementById(
        "custom-cube-all-images-message"
      );

    if (!message) {
      message =
        document.createElement(
          "div"
        );

      message.id =
        "custom-cube-all-images-message";

      message.style.display =
        "none";

      message.style.margin =
        "10px 0";

      message.style.padding =
        "10px 12px";

      message.style.border =
        "1px solid #c62828";

      message.style.borderRadius =
        "4px";

      message.style.background =
        "#fff5f5";

      message.style.color =
        "#c62828";

      message.style.fontSize =
        "13px";

      message.style.fontWeight =
        "600";

      message.style.textAlign =
        "center";

      button.parentElement.insertBefore(
        message,
        button
      );
    }

    return message;
  }

  function validateAllImages(
    button
  ) {
    const inputs =
      getDesignInputs();

    /*
     * Only activate this particular check when
     * exactly six visible design uploads exist.
     */
    if (
      inputs.length !==
      REQUIRED_IMAGE_COUNT
    ) {
      return true;
    }

    const invalidInputs =
      inputs.filter(
        function (input) {
          return (
            input.dataset
              .imageValid !==
            "true"
          );
        }
      );

    const message =
      getCartValidationMessage(
        button
      );

    /*
     * All six images are valid.
     */
    if (
      invalidInputs.length === 0
    ) {
      message.style.display =
        "none";

      message.textContent = "";

      inputs.forEach(
        function (input) {
          const element =
            input.closest(
              ".gpo-element"
            );

          if (element) {
            element.style.outline =
              "";

            element.style.outlineOffset =
              "";
          }
        }
      );

      return true;
    }

    const validCount =
      REQUIRED_IMAGE_COUNT -
      invalidInputs.length;

    message.textContent =
      "Please upload a valid image for all 6 faces before adding this cube to your cart. " +
      validCount +
      " of 6 complete.";

    message.style.display =
      "block";

    /*
     * Highlight missing or invalid fields.
     */
    inputs.forEach(
      function (input) {
        const element =
          input.closest(
            ".gpo-element"
          );

        if (!element) return;

        if (
          input.dataset
            .imageValid ===
          "true"
        ) {
          element.style.outline =
            "";

          element.style.outlineOffset =
            "";
        } else {
          element.style.outline =
            "2px solid #c62828";

          element.style.outlineOffset =
            "3px";
        }
      }
    );

    /*
     * Bring the first problem field into view.
     */
    const firstInvalid =
      invalidInputs[0]?.closest(
        ".gpo-element"
      );

    if (firstInvalid) {
      firstInvalid.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }

    return false;
  }

  // =========================================================
  // INTERCEPT ADD TO CART
  // =========================================================

  document.addEventListener(
    "click",
    function (event) {
      const button =
        event.target.closest(
          "button.gpo-clone-atc-button"
        );

      if (!button) {
        return;
      }

      if (
        !validateAllImages(
          button
        )
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },

    /*
     * Run before Globo's own Add to Cart listener.
     */
    true
  );
})();